import React from 'react';
import PropTypes from 'prop-types';

class RadioButtonInput extends React.PureComponent {
  render() {
    const { name, value, selected, handleChange } = this.props;
    return (
      <input
        ref={input => {
          this.RadioButtonInput = input;
        }}
        type="radio"
        id={`${name}_${value}`}
        name={name}
        className="FormInput__input"
        value={value}
        checked={selected}
        onChange={e => handleChange(e.target)}
      />
    );
  }
}

RadioButtonInput.propTypes = {
  name: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default RadioButtonInput;
